import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=df977a2a&"
import script from "./FooterArea.vue?vue&type=script&lang=js&"
export * from "./FooterArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports